<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          class="mb-6"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <v-card-text>
            <ValidationProvider 
              name="Nomor Surat" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Nomor Surat
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. SRT/PRK/20240102/0001"
                hide-details

                v-model="form.number"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-6"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Nomor Surat {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.number !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>

            <ValidationProvider 
              name="Tujuan Penerima" 
              rules="required" 
              v-slot="{ errors, valid }">
              <div class="body-2 mb-2">
                <span class="red--text">*</span>
                Tujuan Penerima
                <span class="error--text">
                  (wajib diisi)
                </span>
              </div>
              
              <v-text-field
                filled
                rounded
                dense
                :color="set_color"
                
                placeholder="Contoh. John Doe"
                hide-details

                v-model="form.for"
                :success="valid"
                :error-messages="errors"
                required
                class="mb-3"
                style="border-radius: 10px;">
                <template v-slot:append-outer>
                  <div v-if="errors.length > 0">
                    <v-tooltip top color="#ff5252">
                      <template v-slot:activator="{ on }">
                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                      </template>
                      
                      Tujuan Penerima {{ errors[0] }}
                    </v-tooltip>
                  </div>

                  <div v-if="form.for !== '' && valid">
                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                  </div>
                </template>
              </v-text-field>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <ValidationProvider 
          name="Nama File" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama File
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Surat Menyurat"
            hide-details

            v-model="form.title"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama File {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.title !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Nomor" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nomor
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 005/PT.UMB/IV/2022"
            hide-details

            v-model="form.template_meta_json_object.nomor"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nomor {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nomor !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Lampiran" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Lampiran
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. 1 Lembar"
            hide-details

            v-model="form.template_meta_json_object.lampiran"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 50%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Lampiran {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.lampiran !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>   

        <ValidationProvider 
          name="Perihal" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Perihal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Penawaran Produk"
            hide-details

            v-model="form.template_meta_json_object.hal"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px; width: 70%;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Hal {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.hal !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>  

        <ValidationProvider 
          name="Nama Penerima" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Penerima
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Nama Penerima."
            hide-details

            v-model="form.template_meta_json_object.nama_penerima"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Penerima {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_penerima !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <div>
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Tanggal
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>

          <v-menu
            ref="tanggal"
            min-width="290px"
            max-width="290px"
            transition="scale-transition"
            offset-y
            :nudge-right="40"
            :close-on-content-click="false"
            v-model="picker.tanggal">
            <template v-slot:activator="{ on, attrs }">
              <ValidationProvider 
                name="Tanggal" 
                rules="required"
                v-slot="{ errors, valid }">
                <v-text-field
                  readonly
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Pilih Tanggal"
                  hide-details
                  clearable

                  @click:clear="form.template_meta_json_object.tanggal = null;"
                  v-on="on"
                  v-bind="attrs"

                  v-model="form.template_meta_json_object.tanggal"
                  :success="form.template_meta_json_object.tanggal !== null && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Tanggal {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.template_meta_json_object.tanggal !== null && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </template>

            <v-date-picker 
              :color="set_color"
              v-model="form.template_meta_json_object.tanggal"
              @input="picker.tanggal = false">
            </v-date-picker>
          </v-menu>
        </div>

        <ValidationProvider 
          name="Nama Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Nama Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Dr. Alni Rahmawati, SE., MM."
            hide-details

            v-model="form.template_meta_json_object.nama_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Nama Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.nama_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>

        <ValidationProvider 
          name="Jabatan Yang Bertandatangan" 
          rules="required" 
          v-slot="{ errors, valid }">
          <div class="body-2 mb-2">
            <span class="red--text">*</span>
            Jabatan Yang Bertandatangan
            <span class="error--text">
              (wajib diisi)
            </span>
          </div>
          
          <v-text-field
            filled
            rounded
            dense
            :color="set_color"
            
            placeholder="Contoh. Direktur Utama PT.UMB."
            hide-details

            v-model="form.template_meta_json_object.jabatan_1"
            :success="valid"
            :error-messages="errors"
            required
            class="mb-6"
            style="border-radius: 10px;">
            <template v-slot:append-outer>
              <div v-if="errors.length > 0">
                <v-tooltip top color="#ff5252">
                  <template v-slot:activator="{ on }">
                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                  </template>
                  
                  Jabatan Yang Bertandatangan {{ errors[0] }}
                </v-tooltip>
              </div>

              <div v-if="form.template_meta_json_object.jabatan_1 !== '' && valid">
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </div>
            </template>
          </v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        md="6">
        <v-card
          flat
          style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
          <div
            ref="arsippdf"
            style="padding: 50px;">
            <v-card-text
              class="black--text py-2">
              <v-row>
                <v-col
                  cols="12"
                  md="7">
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Nomor
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.nomor !== '' ? form.template_meta_json_object.nomor : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Lam
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : {{ form.template_meta_json_object.lampiran !== '' ? form.template_meta_json_object.lampiran : '__________' }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      Perihal
                    </v-col>

                    <v-col
                      cols="12"
                      md="8"
                      class="py-0"
                      style="padding-top: 0px !important; padding-bottom: 0px !important;">
                      : <span style="font-weight: 500;">{{ form.template_meta_json_object.hal !== '' ? form.template_meta_json_object.hal : '__________' }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <div
                class="mt-0"
                style="margin-top: 8px !important;">
                <div
                  style="margin-bottom: 1px;">
                  Kepada Yth,
                </div>

                <div class="my-3">
                  {{ form.template_meta_json_object.nama_penerima !== '' ? form.template_meta_json_object.nama_penerima : '__________' }}
                </div>

                <div
                  style="margin-bottom: 1px;">
                  Di Tempat
                </div>

              </div>


              <div class="mt-4 px-3" style="padding-left: 12px; margin-top: 16px;">
                <v-img
                  contain
                  width="175"
                  height="auto"
                  alt="umb" 
                  :src="require('@/assets/image/assalam.jpeg')">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <div
                class="mt-8"
                style="margin-top: 8px !important;">

                <div
                  style="margin-bottom: 1px; text-indent: 30px;">
                  Puji syukur marilah kita panjatkan kehadirat Allah SWT yang telah memberikan nikmat iman dan islam kepada kita sampai sekarang ini. Tak lupa shalawat serta salam semoga selalu tercurah kepada Nabi Muhammad SAW. 
                </div>

                <div
                  class="my-4"
                  style="margin-top: 16px !important; margin-bottom: 16px !important;">
                  <div
                    class=""
                    style="margin-bottom: 16px !important; text-indent: 30px;">
                    Bersamaan dengan surat ini kami ingin menawarkan produk dan layanan dari PT UMAT Mandiri Berkemajuan dengan detail penawaran terlampir.
                  </div>

                  <div
                    class="mb-4"
                    style="margin-bottom: 16px !important; text-indent: 30px;">
                    Demikian surat penawaran ini kami sampaikan. Kami sangat berharap dapat menjalin kerja sama yang baik dan saling menguntungkan dengan perusahaan Bapak/Ibu. Atas perhatian kami ucapkan terima kasih.
                  </div>
                </div>

                <div class="px-3" style="padding-left: 12px; margin-bottom: 16px !important;">
                  <v-img
                    contain
                    width="175"
                    height="auto"
                    alt="umb" 
                    :src="require('@/assets/image/wassalam.jpeg')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

              </div>

              <v-row
                justify="end"
                class="mt-8"
                style="display: flex; flex-wrap: wrap; flex: 1 1 auto; justify-content: flex-end !important; margin-top: 32px !important;">
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  style="text-align: right !important;">
                  <div>
                    Yogyakarta, {{ form.template_meta_json_object.tanggal | fulldate }}
                  </div>

                  <div
                    class="mb-16"
                    style="margin-bottom: 64px !important;">
                    {{ form.template_meta_json_object.jabatan_1 !== '' ? form.template_meta_json_object.jabatan_1 : '__________' }}
                  </div>

                  <div>
                    {{ form.template_meta_json_object.nama_1 !== '' ? form.template_meta_json_object.nama_1 : '__________' }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  import html2pdf from 'html2pdf.js'
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      units: {
        type: Array,
        default: []
      },
      process: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        picker: {
          expired: false,
          tanggal: false,
          tanggal_mulai: false,
          tanggal_selesai: false,
          tanggal_masuk: false,

          range: false
        },

        time: {
          pukul: false
        },
      }
    },
    components: {
      
    },
    watch: {

    },
    computed: {
      user () {
        return this.$store.state.user
      },
      
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      // formattedDate: {
      //   get () {
      //     return (this.form.template_meta_json_object.tanggal && this.form.template_meta_json_object.tanggal.length === 10) ? moment(this.form.template_meta_json_object.tanggal).format('DD MMMM YYYY') : this.form.template_meta_json_object.tanggal
      //   },
      //   set (newValue) {
      //     if (newValue && newValue.length == 10) {
      //         let newDate = `${newValue.substring(6, 10)}-${newValue.substring(3, 5)}-${newValue.substring(0, 2)}`
      //         this.form.template_meta_json_object.tanggal = newDate
      //     }
      //   }
      // },

      date_range () {
        return this.filter.dates.join(' s/d ')
      }
    },
    mounted () {
      
    },
    methods: {
      add_pegawai () {
        this.form.template_meta_json_object.kepada.push({
          nama: '',
          unit: ''
        })
      },
      add_desc () {
        this.form.template_meta_json_object.deskripsi.push({
          text: ''
        })
      },
    }
  }
</script>
